<template>
    <div class="slice">
        <!-- Slice section template -->

        <section v-for="(slice, index) in slices" :key="'slice-' + index">

            <!-- Text slice component -->
            <template v-if="slice.slice_type === 'text_section'">
                <div class="container">
                    <text-slice :slice="slice"/>
                </div>
            </template>

            <!-- Icon USP slice component -->
            <template v-else-if="slice.slice_type === 'icon_usp'">
                <div class="container">
                    <icon-usp :slice="slice"/>
                </div>
            </template>

            <!-- Icon USP slice component -->
            <template v-else-if="slice.slice_type === 'code-block'">
                <div class="container">
                    <code-block :slice="slice"/>
                </div>
            </template>

            <!-- Text centered slice component -->
            <template v-else-if="slice.slice_type === 'textcentered'">
                <div class="container">
                    <textcentered :slice="slice"/>
                </div>
            </template>

            <!-- Call 2 Action slice template -->
            <template v-else-if="slice.slice_type === 'cta'">
                <div class="container">
                    <cta :slice="slice"/>
                </div>
            </template>

            <!-- Quote slice component -->
            <template v-else-if="slice.slice_type === 'quote'">
                <div class="container">
                    <quote-slice :slice="slice"/>
                </div>
            </template>

            <!-- Full Width Image slice component -->
            <template v-else-if="slice.slice_type === 'full_width_image'">
                <full-width-image :slice="slice"/>
            </template>

            <!-- Image Gallery slice component -->
            <template v-else-if="slice.slice_type === 'image_gallery'">
                <div class="container">
                    <image-gallery :slice="slice"/>
                </div>
            </template>

            <!-- Image Highlight slice component -->
            <template v-else-if="slice.slice_type === 'image_highlight'">
                <div class="container">
                    <image-highlight :slice="slice"/>
                </div>
            </template>

            <!-- Image with caption slice template -->
            <template v-else-if="slice.slice_type === 'image_with_caption'">
                <image-caption-slice :slice="slice"></image-caption-slice>
            </template>

            <!-- Video embed slice template -->
            <template v-else-if="slice.slice_type === 'video_embed'">
                <video-embed :slice="slice"></video-embed>
            </template>

            <!-- Hero slice template -->
            <template v-else-if="slice.slice_type == 'hero'">
                <hero :slice="slice"></hero>
            </template>

            <!-- Banner With Caption slice template -->
            <template v-else-if="slice.slice_type === 'banner_with_caption'">
                <banner_with_caption :slice="slice"/>
            </template>

        </section>

    </div>
</template>

<script>
    // Imports for all slices
    import Banner_with_caption from "./slices/BannerWithCaption";

    const TextSlice = () => import("./slices/TextSlice.vue");
    const CodeBlock = () => import("./slices/CodeBlock.vue");
    const QuoteSlice = () => import("./slices/QuoteSlice.vue");
    const FullWidthImage = () => import("./slices/FullWidthImage.vue");
    const ImageGallery = () => import("./slices/ImageGallery.vue");
    const ImageHighlight = () => import("./slices/ImageHighlight.vue");
    const ImageCaptionSlice = () => import("../components/slices/ImageCaptionSlice.vue");
    const VideoEmbed = () => import("../components/slices/VideoEmbed.vue");
    const IconUsp = () => import("../components/slices/IconUsp.vue");
    const Cta = () => import("../components/slices/Call2Action.vue");
    const Textcentered = () => import("../components/slices/Textcentered.vue");
    const Hero = () => import("../components/slices/Hero.vue");

    export default {
        props: ['slices'],
        name: 'slices-block',
        components: {
            Banner_with_caption,
            IconUsp,
            TextSlice,
            CodeBlock,
            QuoteSlice,
            FullWidthImage,
            ImageGallery,
            ImageHighlight,
            ImageCaptionSlice,
            VideoEmbed,
            Cta,
            Textcentered,
            Hero
        },
    }
</script>
